export const MAX_PROJECTS: { [key: string]: number } = {
  FREE_USER: 5,
};
